import React from 'react';
import type { CurationCandidate } from '../api/types';
import { STUDIO_COPY } from '../config';

type CandidateClipPreviewProps = {
  candidate: CurationCandidate;
  /** Whether the shared source player can load this clip. */
  previewAvailable: boolean;
  /** Activate the shared ClipSegmentPlayer for this clip. */
  onPreview: (candidate: CurationCandidate) => void;
  isActive?: boolean;
  testIdPrefix?: string;
};

/**
 * Per-card Preview control for Customize/Refine. The actual `<video>` lives in
 * the shared ClipSegmentPlayer — this only arms that player (click-to-play).
 */
const CandidateClipPreview: React.FC<CandidateClipPreviewProps> = ({
  candidate,
  previewAvailable,
  onPreview,
  isActive = false,
  testIdPrefix = 'studio-clip-preview',
}) => {
  return (
    <div data-testid={`${testIdPrefix}-${candidate.candidate_id}`}>
      <button
        type="button"
        className={`studio-btn-ghost text-xs ${
          isActive ? 'ring-1 ring-white/30' : ''
        }`}
        disabled={!previewAvailable}
        title={
          previewAvailable
            ? STUDIO_COPY.customizePreviewTooltip
            : 'Preview unavailable — refresh the source link above'
        }
        aria-label={`Preview ${candidate.label} in the preview above`}
        aria-pressed={isActive}
        data-testid={`${testIdPrefix}-btn-${candidate.candidate_id}`}
        onClick={() => onPreview(candidate)}
      >
        ▶ Preview
      </button>
    </div>
  );
};

export default CandidateClipPreview;
